<template>
  <div class="content">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="/self" class="el-Page1" @click="hrefPage1">物业自有车位</el-menu-item>
      <el-menu-item index="/house" class="el-Page2" @click="hrefPage2">住户车位</el-menu-item>
    </el-menu>
    <div class="home-con">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// import util from '../../../untils/util'
export default {
  isCollapse: false,
  data() {
    return {
      activeIndex: '/self'
    }
  },
  mounted() {
    this.activeIndex = this.$route.path
  },
  methods: {
    hrefPage1() {
      this.$router.push({ name: 'self' })
    },
    hrefPage2() {
      this.$router.push({ name: 'house' })
    },

    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    methods1: function() {
      realconsole()
    }
  }
}
</script>

<style scoped>

* {
  box-sizing: border-box;
}
.home-con {
  height: calc(100% - 80px);
}
.content {
  width: 100%;
  height: 100%;
  min-width: 1080px;
  overflow-y: scroll;
  overflow-x: auto;
  box-sizing: border-box;
}

.con-home-head {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 10px;
}

.content::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

.content::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
}

.content::-webkit-scrollbar-track {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.1);
}

.progress-item .txt >>> .el-progress-bar__outer,
.progress-item .txt >>> .el-progress-bar__inner {
  border-radius: 0;
}
</style>
<style>

* {
  box-sizing: border-box;
}
.home-con {
  height: calc(100% - 80px);
}
.content {
  width: 100%;
  height: 100%;
  min-width: 1080px;
  overflow-y: hidden;
  overflow-x: auto;
  box-sizing: border-box;
}

.content::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

.content::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
}

.content::-webkit-scrollbar-track {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.1);
}

.progress-item .txt >>> .el-progress-bar__outer,
.progress-item .txt >>> .el-progress-bar__inner {
  border-radius: 0;
}
</style>